import React, { Component, createRef } from "react";
import styles from "./DragAndDrop.module.sass";

import Dropzone from "react-dropzone";
import axios from "axios";
import api from "../../utils/api";

class DragAndDrop extends Component {
  state = {
    files: [],
    resetKey: Math.random(),
  };

  onDrop = (files) => {
    if (files.length === 0) {
      return;
    }

    const formData = new FormData();
    formData.append(
      "body",
      JSON.stringify({
        cpfCnpj: this.props.cpfCnpj,
        numeroProposta: this.props.proposalCode,
        numeroContrato: this.props.proposalCode,
        tipoDocumento: this.props.document.tipoDocumento,
      })
    );
    formData.append("file", files[0]);

    axios
      .post(
        process.env.REACT_APP_HOST +
          api.endpoints.DOC_UPLOAD.replace(
            "{{codigo}}",
            this.props.processCode
          ),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((result) => {
        this.setState({ files: files });
      })
      .catch(() => {
        this.setState({
          resetKey: Math.random(),
        });
      });
  };

  onDropRejected = (files) => {
    const rejectedFile = files[0];
    if (
      !["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
        rejectedFile.type
      )
    ) {
      this.props.context.setContext({
        ...this.props.context,
        error: {
          show: true,
          msg:
            "O formato do documento é inválido. Tente formatos como PDF, JPG ou PNG.",
        },
      });
    } else if (rejectedFile.size > 10000000) {
      this.props.context.setContext({
        ...this.props.context,
        error: {
          show: true,
          msg:
            "Seu documento está pesado. O máximo permitido é 10mb. Tente de novo!",
        },
      });
    }
  };

  render() {
    const dropzoneRef = createRef();
    const maxSize = 10000000;

    return (
      <Dropzone
        key={this.state.resetKey}
        ref={dropzoneRef}
        onDrop={this.onDrop}
        onDropRejected={this.onDropRejected}
        accept="image/png, image/jpeg, image/jpg, application/pdf"
        maxSize={maxSize}
        multiple={false}
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isDragReject,
          rejectedFiles,
          acceptedFiles,
        }) => (
          <div
            className={[
              styles.docItem,
              isDragActive ? styles.drag : "",
              acceptedFiles.length > 0 ? styles.accept : "",
            ].join(" ")}
          >
            <div
              {...getRootProps({
                className: [
                  styles.dropzone,
                  acceptedFiles.length > 0 ? styles.active : "",
                ].join(" "),
              })}
            >
              <input {...getInputProps()} />
              <h2 className={styles.titleItem}> {this.props.title}</h2>

              <i
                className={[
                  styles.iconDoc,
                  acceptedFiles.length > 0
                    ? "icon icon-check-p"
                    : "icon icon-adicionar",
                ].join(" ")}
              />

              <p className={styles.textContent}>
                {acceptedFiles.length > 0
                  ? "Arquivo enviado!"
                  : "Clique aqui ou arraste e solte o(s) arquivo(s) para enviar"}
                <span className={styles.docType}>
                  PDF,JPG ou PNG - max 10MB
                </span>
              </p>
            </div>
          </div>
        )}
      </Dropzone>
    );
  }
}

export default DragAndDrop;
